module.exports = __webpack_public_path__ + "static/media/header.f1d55a95.png";